export default {
  book: {
    title: 'Book Confirm',
    trainInfo: 'Train Info',
    seatPreference: 'Seat Preference',
    passengerInfo: 'Passenger Info',
    bookingNotice: 'Booking Notice',
    paymentConfirmation: 'Payment Confirmation',
    soldOut: 'Sold Out',
    tip: 'To confirm your reservation, please complete the operation as soon as possible',
    passenger: {
      count: 'Number of passengers',
      representative: 'Passenger Representative',
      representativeTip: "(only main passenger's information required.)",
      lastName: 'Last Name',
      firstName: 'First Name',
      email: 'Email address (for sending reservation information)'
    }
  },
  bookConfirm: {
    paymentInfo: 'Payment Information',
    paymentConfirmation: {
      warningTitle: 'Please confirm the cancellation policy:',
      warningText: 'Once purchased, this product cannot be refunded.',
      agreementText: 'I have read and agree to the Terms and Conditions.'
    },
    paymentAmount: {
      total: 'Total',
      details: 'Details',
      note: 'For non-JPY currencies, the displayed amount is an estimate based on the current exchange rate and may differ slightly from the actual charge. For reference only.'
    }
  },
  bookResult: {
    successMessage:
      'Reservation completed.\nPlease check the order details for ticketing results.'
  }
};
